var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D8DFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5714 27.4286V28.5714H10V27.4286L12.2857 25.1429V18.2857C12.2857 14.7429 14.6057 11.6229 18 10.6171V10.2857C18 9.67951 18.2408 9.09812 18.6695 8.66947C19.0981 8.24082 19.6795 8 20.2857 8C20.8919 8 21.4733 8.24082 21.902 8.66947C22.3306 9.09812 22.5714 9.67951 22.5714 10.2857V10.6171C25.9657 11.6229 28.2857 14.7429 28.2857 18.2857V25.1429L30.5714 27.4286ZM22.5714 29.7143C22.5714 30.3205 22.3306 30.9019 21.902 31.3305C21.4733 31.7592 20.8919 32 20.2857 32C19.6795 32 19.0981 31.7592 18.6695 31.3305C18.2408 30.9019 18 30.3205 18 29.7143",
    fill: "#3876BB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsMenuIcon);
export default __webpack_public_path__ + "static/media/NotificationsMenuIcon.0afb2f3d0b13efd525b12d9b6427b11e.svg";
export { ForwardRef as ReactComponent };